<template>
    <FormWrapper>
        <PageTitle title="Update Forgot to Punch" slot="title" link="/helpContent/Leave Approve" />
        <div v-html="userName" id="sub-heading"></div>
        <br />
        <br />
        <ValidationObserver ref="validator" >
            <FormRow>
                <div class="col-sm-4">
                    <InputDate label="Date" v-model="form.date" :style="{pointerEvents: display}" /> 
                </div>
                <div class="col-sm-4">
                    <InputText v-model="form.time" label="Time" :style="{pointerEvents: display}" />
                </div>
                <div class="col-sm-4">
                    <RadioGroup v-model="form.timeAmPm" style="margin-right: 10px;" :style="{pointerEvents: display}" >
                        <Radio label="AM">
                            AM
                        </Radio>
                        <Radio label="PM">
                            PM
                        </Radio>
                    </RadioGroup>
                </div>
            </FormRow>
            <FormRow> 
                <div class="col-sm-6">
                    <RadioGroup v-model="form.timeInOut" :style="{pointerEvents: display}" >
                        <Radio label="timeIn">
                            Time In
                        </Radio>
                        <Radio label="timeOut">
                            Time Out
                        </Radio>
                    </RadioGroup>
                </div>
                <div class="col-sm-4">
                    <InputTextArea v-model="form.reason" label="Reason" :style="{pointerEvents: display}" />
                </div>
            </FormRow>
            <FormRow>
                <h4>Manager Comments</h4>
                <br/>
                <div class="col-sm-4">
                    <InputTextArea v-model="form.notes" label="Notes" />
                </div>
            </FormRow>
            <br>
        </ValidationObserver>
        <FormRow>
            <div class="col-sm-6">
                <ButtonGroup>
                    <FormButton type="info" @click="()=>{$router.go(-1)}">Back</FormButton>
                    <FormButton type="success" @click="onAprroveOrReject(1)">Approve</FormButton>
                    <FormButton type="danger" @click="onAprroveOrReject(0)">Reject</FormButton>
                </ButtonGroup>
            </div>
        </FormRow>
        <FormRow>
            <div class="col-md-12">
                <h4>Leave Matrix</h4>
                <DataTable :actions="true"
                    :data="leaveMatrixData"
                    :columns="tableLeaveMatrix"
                    :is-loading="isLoading">
                </DataTable>
            </div>
        </FormRow>
        <Popup title="Success" type="success" :value="showMessage.isVisible"  @close="() => (showMessage.isVisible = false)" :closable="true">
            {{ showMessage.message }}
            <div slot="footer">
                <FormButton @click="()=>{$router.go(-1)}">Ok</FormButton>
            </div>
        </Popup>
    </FormWrapper>
</template> 

<script>
    import FormWrapper from 'Components/form/FormWrapper';
    import PageTitle from 'Components/layout/PageTitle';
    import loadingMixin from 'Mixins/loadingMixin';
    import {getUserNameById, leaveMatrix, getMissedPunchListById, updateMissedPunchStatus} from '../api';
    import InputDate from "Components/form/InputDate";
    import tableLeaveMatrix from "./tableLeaveMatrix";
    import DataTable from "Components/DataTable";
    import { RadioGroup, Radio } from "view-design";
    import { ValidationObserver } from 'vee-validate';
    export default {
        name: "Update",
        mixins: [loadingMixin],
        components: {
            FormWrapper,
            PageTitle,
            DataTable,
            InputDate,
            ValidationObserver,
            RadioGroup,
            Radio,
        },
        data() {
            return {
                showMessage:{
                    isVisible: false,
                    message: ''
                },
                form:{
                    date: '',
                    time:'',
                    timeAmPm: '',
                    timeInOut: '',
                    reason: '',
                    notes:''
                },
                display:'none !important',
                userName: '',
                tableLeaveMatrix,
                leaveMatrixData: []
            }
        },
        computed: {
          userData() {
              return this.$store.state.user.user
            }
        },
        watch: {
        },
        created() {
            this.getAllList(),
            this.getLeaveRecord(),
            this.getDataByFilter()
        },
        methods: {
            getDataByFilter() {
                if(this.$route.params.id){
                    setTimeout(() => {
                        this.showLoader();
                        const filters = {};
                        filters.punchId = atob(this.$route.params.id);
                        const data = {
                            filterjson: {
                                filter: [filters]
                            }
                        };
                        getMissedPunchListById(data)
                            .then(this.handleResponse)
                            .catch(this.handleError)
                    },
                    50
                    )
                }
            },
            onAprroveOrReject(val){
                this.$refs.validator.validate().then(result=>{
                    if(result){
                        this.showMessage.isVisible=false;
                        const data={
                            punchId: this.$route.params.id?atob(this.$route.params.id):0,
                            toDoId: this.$route.params.toDoId?atob(this.$route.params.toDoId):0,
                            statusId: (val===1)?86:88, //86 -> Approved & 88 -> Reject
                            approvalComment: this.form.notes
                        };
                        updateMissedPunchStatus(data).then((res)=>{
                            this.form = {};
                            this.showMessage.isVisible=true;
                            this.showMessage.message=res.data[0].message;
                        })
                    }
                })
            },
            handleResponse(response) {
                this.hideLoader();
                this.form.date = response.data[0].date;
                const timeArray = response.data[0].Time.split(" ");
                this.form.time = timeArray[0];
                this.form.timeAmPm = timeArray[1];
                this.form.timeInOut = response.data[0]['In/Out'];
                this.form.reason = response.data[0].notes;
            },
            getLeaveRecord() {
                if (this.$route.params.staffId) {
                    let data = {
                        staff_id: atob(this.$route.params.staffId),
                    };
                    leaveMatrix(data).then((res) => {
                        this.leaveMatrixData = res.data;
                    });
                }
            },
            async getAllList() {
                const filters = {};
                filters.userId = atob(this.$route.params.staffId);
                const data = {
                    filterjson: {
                        filter: [filters]
                    }
                };
                await getUserNameById(data).then((res)=>{
                    this.userName = res.data[0].name;
                });
            },
        }
    } 
</script>
<style lang="scss">
    #sub-heading{
        font-weight: 900;
        float: right;
    }

    body{
        padding-right: 0px !important;
        overflow: auto !important;
    }
</style>